import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useComponent } from '../../../hooks/useComponent';
import { renderComponent } from '../../../utils/renderComponent';
import { StyledGroupOf2 } from './styles';
const GroupfOf2 = (props) => {
    var _a;
    const groupOf2 = useComponent(props.entryId, props.componentType);
    const { direction, percentSplit, minHeight, minHeightMobile, components, backgroundColor, } = (_a = groupOf2 === null || groupOf2 === void 0 ? void 0 : groupOf2.fields) !== null && _a !== void 0 ? _a : {};
    const theme = useTheme();
    const isWithAssets = direction === 'row' &&
        (components === null || components === void 0 ? void 0 : components[1].sys.contentType.sys.id) === 'assetsListComponent';
    const containerBackgroundColor = theme.colors[backgroundColor];
    const containerProps = {
        styles: {
            content: {
                position: 'relative',
                zIndex: 1,
            },
        },
        noPadding: direction === 'column',
        containerBackgroundColor,
        removeContainer: direction === 'column',
    };
    return (_jsx(StyledGroupOf2, Object.assign({ "$direction": direction, "$percentSplit": percentSplit, "$minHeight": minHeight, "$minHeightMobile": minHeightMobile, "$isWithAssets": isWithAssets }, containerProps, { children: components === null || components === void 0 ? void 0 : components.map((component) => renderComponent(component, true, props.additionalFields)) })));
};
export default GroupfOf2;
